<template>
	<inertia-head title="Create Community" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Create Community
					</h1>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		
		<div class="row">
			<div class="col-lg-8 mb-6">
				<div class="mb-4">
					<label class="form-label" for="community_name">Community Name </label>
					<input type="text" @blur="checkCommunityName" v-model="formCommunity.community_name" name="community_name" class="form-control" maxlength="21">
					<div class="text-end text-danger fs-sm">Max:21 Length</div>
					<div class="text-end text-danger fs-sm">Allowed: letters and numbers</div>
					<div v-if="formCommunity.errors.community_name" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ formCommunity.errors.community_name }}
					</div>
				</div>
				<div class="mb-4">
					<label class="form-label" for="description">Description</label>
					<textarea v-model="formCommunity.description" name="description" rows="5" class="form-control"></textarea>
					<div v-if="formCommunity.errors.description && (formCommunity.description=='' || formCommunity.description==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ formCommunity.errors.description }}
					</div>
				</div>
				<div class="form-group mb-4">
					<label class="form-label" for="status">Status</label>

	                <div class="form-group">
		                <div class="form-check form-block mb-2">
							<input
								v-model="formCommunity.status"
								class="form-check-input"
								type="radio"
								:value="'Public'"
								id="public"
								name="status"
							/>
							<label class="form-check-label" for="public">
								<p class="fw-bold m-0">PUBLIC</p>
								<span>Anyone can view, post, and comment to this community</span>
							</label>
						</div>
					</div>
					<div class="form-group">
		                <div class="form-check form-block mb-2">
							<input
								v-model="formCommunity.status"
								class="form-check-input"
								type="radio"
								:value="'Restricted'"
								id="restricted"
								name="status"
							/>
							<label class="form-check-label" for="restricted">
								<p class="fw-bold m-0">RESTRICTED</p>
								<span>Anyone can view, but only approved user can contribute</span>
							</label>
						</div>
					</div>
					<div class="form-group">
		                <div class="form-check form-block mb-4">
							<input
								v-model="formCommunity.status"
								class="form-check-input"
								type="radio"
								:value="'Private'"
								id="private"
								name="status"
							/>
							<label class="form-check-label" for="private">
								<p class="fw-bold m-0">PRIVATE</p>
								<span>Only approved user can view and contribute</span>
							</label>
						</div>
					</div>

					<div v-if="formCommunity.errors.status && (formCommunity.status=='' || formCommunity.status==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.status }}
					</div>
				</div>

				<div class="mb-4">
					<button @click="createCommunity" type="button" class="text-end btn btn-alt-success" :disabled="formCommunity.processing">
						<div
							v-if="formCommunity.processing"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-save me-1"></i>
						<span>Create Community</span>
					</button>
				</div>
			</div>

			<div class="col-lg-4 mb-6">

			</div>

		</div>

	</div>
</template>

<script>
import { watch, onMounted, ref } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { createToaster } from '@meforma/vue-toaster';
import { useForm, usePage } from '@inertiajs/inertia-vue3';

export default {
	props:{
		flash 		: Object,
		errors 		: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const formCommunity = useForm({
			community_name 		: null,
			description 		: null,
			banner_logo 		: null,
			icon_logo 			: null,
			topics 				: null,
			status 				: "Public",
		});

		const checkCommunityName = ()=>{

			formCommunity.post(route('member.community.communityname-check'), {
							preserveState: true,
							preserveScroll: true,
							only: ['errors'],
						})

		}

		const createCommunity = ()=>{

			formCommunity.post(route('member.community.community-store'), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								
							}
						})
		}


		return{
			toast,
			formCommunity,
			checkCommunityName,
			createCommunity
		}

	}
}
</script>